import React, { useEffect, useState } from 'react';

// "A new version is ready" bar.
//
// A page that is left open keeps running the code it loaded, so after an update
// people went on using the old screens until they happened to refresh. Each
// build writes asset-manifest.json with the name of its main script; this
// compares that with the script this tab is running. When they differ it shows
// a bar with a Refresh button. It never reloads a signed-in screen by itself
// (that could interrupt a call or lose a half-filled form); only a sign-in
// screen, where nothing can be lost, refreshes on its own.
//
// Cost: one tiny request a minute and when the tab becomes visible again.
const TOKEN_KEYS = ['admin_token', 'agent_token', 'trainee_token'];
const runningScript = () => {
  const src = [...document.scripts].map(s => s.src || '').find(u => /\/static\/js\/main\.[0-9a-f]+\.js/.test(u));
  return src ? src.replace(/^.*\/static\/js\//, '') : null;
};

export default function UpdateBanner() {
  const [stale, setStale] = useState(false);

  useEffect(() => {
    const mine = runningScript();
    if (!mine) return undefined;   // development server: nothing to compare
    let stopped = false;
    const check = async () => {
      try {
        const r = await fetch(`${process.env.PUBLIC_URL || ''}/asset-manifest.json?_=${Date.now()}`, { cache: 'no-store' });
        if (!r.ok) return;
        const j = await r.json();
        const latest = String((j.files && j.files['main.js']) || '').replace(/^.*\/static\/js\//, '');
        if (!stopped && latest && latest !== mine) setStale(true);
      } catch (_) { /* offline or mid-deploy: try again next time */ }
    };
    check();
    const iv = setInterval(check, 60000);
    const onVisible = () => { if (document.visibilityState === 'visible') check(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => { stopped = true; clearInterval(iv); document.removeEventListener('visibilitychange', onVisible); };
  }, []);

  useEffect(() => {
    if (!stale) return;
    let signedIn = false;
    try { signedIn = TOKEN_KEYS.some(k => !!localStorage.getItem(k)); } catch (_) { signedIn = true; }
    if (!signedIn) window.location.reload();
  }, [stale]);

  if (!stale) return null;
  return (
    <div data-update-banner role="status" style={{
      position: 'fixed', top: 10, left: '50%', transform: 'translateX(-50%)', zIndex: 10050,
      display: 'flex', alignItems: 'center', gap: 12, padding: '8px 8px 8px 16px', borderRadius: 999,
      background: 'linear-gradient(135deg,#0b2a5c 0%,#0369a1 100%)', color: '#fff',
      boxShadow: '0 14px 30px -12px rgba(12,59,110,0.7)', fontSize: 13, fontWeight: 600, whiteSpace: 'nowrap'
    }}>
      <span>A new version of BluDialer is ready.</span>
      <button onClick={() => window.location.reload()} style={{
        border: 'none', cursor: 'pointer', borderRadius: 999, padding: '7px 14px', fontSize: 12.5, fontWeight: 800,
        background: 'linear-gradient(135deg,#2563eb 0%,#06b6d4 100%)', color: '#fff'
      }}>Refresh now</button>
    </div>
  );
}
